var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkspaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 37,
    height: 37,
    rx: 7,
    fill: "#05F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 43,
    height: 43,
    rx: 9,
    stroke: "#05F",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1117 27.5592H19.2512V22.1426H17.1117V27.5592ZM25.8054 27.5592H27.945V16.6988H25.8054V27.5592ZM21.4721 27.5592H23.5846V24.3092H21.4721V27.5592ZM21.4721 22.1426H23.5846V20.003H21.4721V22.1426ZM14.8908 31.8926C14.313 31.8926 13.8165 31.6849 13.4012 31.2697C12.986 30.8544 12.7783 30.3579 12.7783 29.7801V14.5051C12.7783 13.9273 12.986 13.4308 13.4012 13.0155C13.8165 12.6002 14.313 12.3926 14.8908 12.3926H30.1658C30.7436 12.3926 31.2401 12.6002 31.6554 13.0155C32.0707 13.4308 32.2783 13.9273 32.2783 14.5051V29.7801C32.2783 30.3579 32.0707 30.8544 31.6554 31.2697C31.2401 31.6849 30.7436 31.8926 30.1658 31.8926H14.8908ZM14.8908 29.7801H30.1658V14.5051H14.8908V29.7801ZM14.8908 14.5051V29.7801V14.5051Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(10 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceIcon);
export default __webpack_public_path__ + "static/media/workspaceIcon.36ff63e423f89fa1d4d6b3b1c58764a8.svg";
export { ForwardRef as ReactComponent };